import { Component, ElementRef, ViewChild, Input, Renderer2, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Component({
	selector: 'bb-canvas-element',
	templateUrl: './bb-canvas-element.component.html',
	styleUrls: ['./bb-canvas-element.component.scss']
})

export class BbCanvasElementComponent implements AfterViewInit {
	@ViewChild('canvasContainer', { static: true }) canvasContainerElementRef: ElementRef;
	@ViewChild('canvas', { static: true }) canvasElementRef: ElementRef;

	@Input() width: number;
	@Input() height: number;

	@Output() canvasContextChange: EventEmitter<CanvasRenderingContext2D> = new EventEmitter<CanvasRenderingContext2D>();

	canvasContext: CanvasRenderingContext2D;
	initialized = false;

	private resizeObserver: any;

	constructor(private renderer: Renderer2) { }

	ngAfterViewInit() {
		this.setSize();

		this.initializeCanvas();
		this.initResizeObserver();
	}

	initResizeObserver() {
		this.resizeObserver = new ResizeObserver(entries => {
			if (this.initialized) {
				requestAnimationFrame(() => {
					this.setSize();
				});
			}
		});

		this.resizeObserver.observe(this.canvasContainerElementRef.nativeElement);
	}

	setSize() {
		if (!this.width) {
			if (this.canvasContainerElementRef) {
				this.width = this.canvasContainerElementRef.nativeElement.clientWidth;
			}
		}
		if (this.width) {
			this.renderer.setAttribute(this.canvasElementRef.nativeElement, 'width', '' + this.width);
		}
		if (this.height) {
			this.renderer.setAttribute(this.canvasElementRef.nativeElement, 'height', '' + this.height);
		}
	}

	initializeCanvas() {
		this.setSize();
		this.initialized = true;
		this.canvasContext = this.canvasElementRef.nativeElement.getContext('2d');
		this.canvasContextChange.emit(this.canvasContext);
	}

	clearCanvas() {
		this.canvasContext.clearRect(0, 0, this.width || this.canvasContainerElementRef?.nativeElement?.clientWidth, this.height);
	}
}
